import { createStore, combineReducers } from 'redux'

// Initial Sidebar State
const initialSidebarState = {
  sidebarShow: true,
}

// Sidebar Reducer
const sidebarReducer = (state = initialSidebarState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

// Initial Loader State
const initialLoaderState = {
  isLoading: false,
}

// Loader Reducer
const loaderReducer = (state = initialLoaderState, action) => {
  switch (action.type) {
    case 'SHOW_LOADER':
      return { isLoading: true }
    case 'HIDE_LOADER':
      return { isLoading: false }
    default:
      return state
  }
}

// Combine Reducers
const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  loader: loaderReducer,
})

// Create Store
const store = createStore(rootReducer)

export default store
